import { useRef } from 'react';
import { Editor, defaultValueCtx, rootCtx } from '@milkdown/core';
import { Milkdown, MilkdownProvider, useEditor } from '@milkdown/react';
import { commonmark } from '@milkdown/preset-commonmark';
import { gfm } from '@milkdown/preset-gfm';
import { history } from '@milkdown/plugin-history';
import { listener, listenerCtx } from '@milkdown/plugin-listener';
import { nord } from '@milkdown/theme-nord';
import '@milkdown/theme-nord/style.css';
import '../styles/milkdown-dark.css';

import EditorToolbar from './EditorToolbar';

interface MilkdownEditorProps {
  initialContent: string;
  onChange: (markdown: string) => void;
  autoFocus?: boolean;
  showToolbar?: boolean;
}

function MilkdownInner({ initialContent, onChange, showToolbar }: MilkdownEditorProps) {
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEditor((root) => {
    return Editor.make()
      .config(nord)
      .config((ctx) => {
        ctx.set(rootCtx, root);
        ctx.set(defaultValueCtx, initialContent);
        ctx.get(listenerCtx).markdownUpdated((_ctx, markdown, prevMarkdown) => {
          if (markdown !== prevMarkdown) {
            onChangeRef.current(markdown);
          }
        });
      })
      .use(commonmark)
      .use(gfm)
      .use(history)
      .use(listener);
  }, [initialContent]);

  return (
    <div className="milkdown-wrapper">
      {showToolbar && <EditorToolbar />}
      <Milkdown />
    </div>
  );
}

export default function MilkdownEditor(props: MilkdownEditorProps) {
  return (
    <MilkdownProvider>
      <MilkdownInner {...props} />
    </MilkdownProvider>
  );
}
